const LOCAL_STORAGE_FAVOURITES_KEY = 'my-favourites';
// LOCAL_STORAGE_RECENTLY_VIEWED_KEY used without variable on main-product.liquid
const LOCAL_STORAGE_RECENTLY_VIEWED_KEY = 'recently-viewed';
const LOCAL_STORAGE_DELIMITER = ',';
const ON_CHANGE_DEBOUNCE_TIMER = 300;

const USER_INTERACTION_ANALYTICS_EVENTS = {
    cartUpdate: 'cart-update',
    quantityUpdate: 'quantity-update',
    variantChange: 'variant-change',
    cartError: 'cart-error',
    viewItem: 'view-item',
    selectItem: 'select-item',
    viewItemList: 'view-item-list',
    pageView: 'page-view',
    search: 'search',
    login: 'login',
    logout: 'logout',
    storeLocator: 'store-locator',
    repeatPurchase: 'repeat-purchase',
    subscribeToggle: 'subscribe-toggle',
    subscribeAction: 'subscribe-action',
    cartView: 'cart-view',
    cart: 'cart',
    filter: 'filter',
    ageVerified: 'age-verified',
    searchResultClick: 'search-result-click',
    beginCheckout: 'begin-checkout',
    purchase: 'purchase',
    registration: 'registration',
    registrationStart: 'registration-start',
    updateSubscription: 'update-subscription',
    checkoutAddress: 'checkout-address',
    newsletter: 'newsletter',
    freeTrialQuiz: 'free-trial-quiz',
    freeTrialQuizStep: 'free-trial-quiz-step',
};
